import React, { FC } from 'react';
import { Spinner } from './Spinner';
import { COLORS } from '../globalStyle/colors';


type LoaderProps = {
  className?: string;
  color?: string;
}

export const Loader: FC<LoaderProps> = (props: LoaderProps) => (
  <div className={props.className}>
    <Spinner fill={props.color ?? COLORS.GREEN} />
  </div>
);
